import { LINK_LOAN_LIST } from "transactionRoutes";
import {
  LOAN_SIDEBAR_BACK_URL_BEGIN,
  LOAN_SIDEBAR_BACK_URL_FAILURE,
  LOAN_SIDEBAR_BACK_URL_SUCCESS,
} from "../actions/1_ActionConstants";

const initialState = {
  loading: false,
  error: null,
  profileObj: {},
};

export default function SidebarBackToListReducer(state = initialState, action) {
  switch (action.type) {
    case LOAN_SIDEBAR_BACK_URL_BEGIN:
      return {
        ...state,
      };

    case LOAN_SIDEBAR_BACK_URL_SUCCESS:
      return {
        ...state,
        loading: false,
        screen: action.payload,
      };

    case LOAN_SIDEBAR_BACK_URL_FAILURE:
      return {
        ...state,
        loading: false,
        error: "FAILED TO LOAD,..,.", //action.payload.error,
        screen: LINK_LOAN_LIST,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
}
